import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthService} from "../../../shared/services/auth.service";
import {TranslateService} from "@ngx-translate/core";

const baseUrl = `${environment.services_api_url}${environment.v1}/Shared`

@Injectable({
  providedIn: 'root'
})
export class GiveawayService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private translateService: TranslateService
  ) {
  }

  private getHeader(): HttpHeaders {
    let httpHeaders = this.authService.getHeader();
    httpHeaders = httpHeaders
      .set('X-Payment-Client', environment.xApiClient)
      .set('Accept-Language', this.translateService.currentLang);
    return httpHeaders;
  }

  getGiveawayEventAvailable(reference: string){
    const queryParams = {reference: reference}
    return this.http.get(baseUrl + '/GiveawayEvent/GetAvailable', {headers: this.getHeader(), params: queryParams})
  }

  submitGiveaway(data: any){
    return this.http.post(baseUrl + '/Giveaway/Submit',data, {headers: this.getHeader()})
  }

  getWinnersList() {
    const queryParams = {reference: 'Giveaway'}
    return this.http.get(baseUrl + '/GiveawayEvent/GetWinners', {params: queryParams, headers: this.getHeader()})
  }
}
